import { render, staticRenderFns } from "./PartnerFigures.vue?vue&type=template&id=96077ec0"
import script from "./PartnerFigures.vue?vue&type=script&lang=js"
export * from "./PartnerFigures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports